module.exports = __webpack_public_path__ + "static/media/alert_train_selected_hover.0dc8cb7c.svg";